import type { NandaDiagnoseSummary, NandaDomein, NandaKlasse } from '@/services';
import type { NandaDiagnoseView } from '../types/careplan-nnn.types';

export function buildNandaDiagnoseIndex(
  diagnoses: NandaDiagnoseSummary[],
  domeinen: NandaDomein[],
  klassen: NandaKlasse[]
): Map<string, NandaDiagnoseView> {
  const domeinNamen = new Map(domeinen.map(domein => [domein.nummer, domein.naam]));
  const klasseNamen = new Map(klassen.map(klasse => [`${klasse.domeinNummer}:${klasse.nummer}`, klasse.naam]));
  return new Map(
    diagnoses.map(diagnose => [
      diagnose.id,
      {
        ...diagnose,
        domeinNaam: diagnose.domein != null ? (domeinNamen.get(diagnose.domein) ?? null) : null,
        klasseNaam:
          diagnose.domein != null && diagnose.klasse != null
            ? (klasseNamen.get(`${diagnose.domein}:${diagnose.klasse}`) ?? null)
            : null,
      },
    ])
  );
}
